import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";


const HistoryPage = () => {
    const { id } = useParams();
    const [history, setHistory] = useState([]);
    const navigate = useNavigate();
    

    useEffect(() => {
        fetch(`/api/get_text_history/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.history) {
                    setHistory(data.history);
                }
            })
            .catch(error => console.error("Error fetching history:", error));
    }, [id]);

    const restoreVersion = (field, oldText) => {
        fetch(`/api/update_text`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                page_id: id,
                field: field,
                new_text: oldText
            })
        })
        .then(response => response.json())
        .then(data => {
            alert(data.message || "Text restored successfully!");
        })
        .catch(error => console.error("Error restoring text:", error));
    };

    const deleteHistoryEntry = (entryId) => {
        console.log("this is the entryId",entryId)
        if (!window.confirm("Are you sure you want to delete this history entry?")) return;

        fetch(`/delete_history_entry/${entryId}`, {
            method: "DELETE"
        })
        .then(response => response.json())
        .then(data => {
            alert(data.message || "History entry deleted successfully!");
            setHistory(history.filter(entry => entry._id !== entryId)); // Remove deleted entry from UI
        })
        .catch(error => console.error("Error deleting history entry:", error));
    }; 




    return (
        <div className="min-h-screen bg-gray-100 p-6">
            <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6">
                 
                 <div className="mt-6">
                    <button
                        onClick={() => navigate(`/edit/${id}`)}
                        className="p-2 rounded hover:bg-gray-200"
                    >
                        ← 
                    </button>
                </div>
                <h1 className="text-2xl font-bold text-gray-800 mb-4">Text History</h1>

                <table className="w-full border-collapse border border-gray-300">
                    <thead>
                        <tr className="bg-gray-200 text-gray-700">
                            <th className="border border-gray-300 px-4 py-2 text-left">Field</th>
                            <th className="border border-gray-300 px-4 py-2 text-left">Old Text</th>
                            <th className="border border-gray-300 px-4 py-2">Timestamp</th>
                            <th className="border border-gray-300 px-4 py-2">Restore</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.length > 0 ? (
                            history.map((entry, index) => (
                                <tr key={index} className="border-b hover:bg-gray-50">
                                    <td className="border border-gray-300 px-4 py-2">{entry.field}</td>
                                    <td className="border border-gray-300 px-4 py-2">{entry.old_text}</td>
                                    <td className="border border-gray-300 px-4 py-2 text-center">
                                        {new Date(entry.timestamp).toLocaleString()}
                                    </td>
                                    <td className="border border-gray-300 px-4 py-2 text-center flex justify-center items-center space-x-4 ">
                                        <button
                                            onClick={() => restoreVersion(entry.field, entry.old_text)}
                                            className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 transition duration-200"
                                        >
                                            Restore
                                        </button>
                                        <button 
                                                onClick={() => deleteHistoryEntry(entry._id)}
                                                className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition duration-200"
                                            >
                                                Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center py-4 text-gray-500">
                                    No history available.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                
            </div>
        </div>
    );
};

export default HistoryPage;